"use strict";
var Observable_1 = require('../../Observable');
var bufferTime_1 = require('../../operator/bufferTime');
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/~/rxjs/add/operator/bufferTime.js
// module id = ../../../../rxjs/add/operator/bufferTime.js
// module chunks = 5